var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "700" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("add")]),
                  _vm._v(" Asignación de horarios por unidad\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "py-0 px-3",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field-reducido",
                                attrs: {
                                  items: _vm.unidades,
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  "item-text": function(val) {
                                    return val.nombre_unidad
                                  },
                                  label: "Seleccione la unidad/área",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  loading: _vm.loading,
                                  outline: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.id_unidad,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_unidad", $$v)
                                  },
                                  expression: "form.id_unidad"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "text-field-reducido",
                                  on: {
                                    change: function($event) {
                                      return _vm.obtenerHorarios(
                                        _vm.tipo_asignacion
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.tipo_asignacion,
                                    callback: function($$v) {
                                      _vm.tipo_asignacion = $$v
                                    },
                                    expression: "tipo_asignacion"
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" }
                                        },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Continuo",
                                              value: "1"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md6: "" }
                                        },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Discontinuo",
                                              value: "2"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido",
                                attrs: {
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "Fecha de inicio",
                                  outline: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.fecha_desde,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde", $$v)
                                  },
                                  expression: "form.fecha_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido",
                                attrs: {
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "Fecha de finalización",
                                  outline: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.fecha_hasta,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_hasta", $$v)
                                  },
                                  expression: "form.fecha_hasta"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.tipo_asignacion
                            ? _c(
                                "v-flex",
                                {
                                  class:
                                    _vm.tipo_asignacion == "1" ? "md12" : "md6"
                                },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      items: _vm.horarios,
                                      "item-value": function(val) {
                                        return parseInt(val.id)
                                      },
                                      "item-text": function(val) {
                                        return (
                                          val.descripcion +
                                          ": " +
                                          val.hora_inicio +
                                          " - " +
                                          val.hora_fin
                                        )
                                      },
                                      label:
                                        _vm.tipo_asignacion === "1"
                                          ? "Seleccione horario"
                                          : "Seleccione primer horario",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.id_horario,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "id_horario", $$v)
                                      },
                                      expression: "form.id_horario"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.tipo_asignacion === "2"
                            ? _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      items: _vm.horarios2,
                                      "item-value": function(val) {
                                        return parseInt(val.id)
                                      },
                                      "item-text": function(val) {
                                        return (
                                          val.descripcion +
                                          ": " +
                                          val.hora_inicio +
                                          " - " +
                                          val.hora_fin
                                        )
                                      },
                                      label: "Seleccione segundo horario",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.id_horario2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "id_horario2", $$v)
                                      },
                                      expression: "form.id_horario2"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: !_vm.valid
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e95fdca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e95fdca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asignacion_horario/dialogs/AsignarHorario.vue
// module id = null
// module chunks = 